import React, { useState, useEffect } from "react";

import { AtomCurrentProfileName } from "../components/atom/AtomCurrentProfileName";
import { AtomUsersUrl } from "../components/atom/AtomUsersUrl";
import { AtomUsername } from "../components/atom/AtomUsername";
import { AtomWork } from "../components/atom/AtomWork";
import { AtomDescription } from "../components/atom/AtomDescription";
import { AtomUserid } from "../components/atom/AtomUserid";
import { AtomLevel } from "../components/atom/AtomLevel";
import { AtomBirthdayDisplay } from "../components/atom/AtomBirthdayDisplay";
import { AtomCurrentFontName } from "../components/atom/AtomCurrentFontName";
import { AtomColor } from "../components/atom/AtomColor";
import { AtomBalanceRP } from "../components/atom/AtomBalanceRP";
import { AtomCurrentProfileUrl } from "../components/atom/AtomCurrentProfileUrl";
import { AtomCurrentProfileAvailable } from "../components/atom/AtomCurrentProfileAvailable";
import { AtomCurrentBadgeAvailable } from "../components/atom/AtomCurrentBadgeAvailable";
import { AtomCurrentBgName } from "../components/atom/AtomCurrentBgName";
import { AtomCurrentBgAvailable } from "../components/atom/AtomCurrentBgAvailable";
import { AtomCurrentBadge1Name } from "../components/atom/AtomCurrentBadge1Name";
import { AtomCurrentBadge1Url } from "../components/atom/AtomCurrentBadge1Url";
import { AtomCurrentBadge2Name } from "../components/atom/AtomCurrentBadge2Name";
import { AtomCurrentBadge2Url } from "../components/atom/AtomCurrentBadge2Url";
import { AtomCurrentBadge3Name } from "../components/atom/AtomCurrentBadge3Name";
import { AtomCurrentBadge3Url } from "../components/atom/AtomCurrentBadge3Url";
import { AtomCurrentBadge4Name } from "../components/atom/AtomCurrentBadgeName";
import { AtomCurrentBadge4Url } from "../components/atom/AtomCurrentBadge4Url";
import { AtomCurrentBgUrl } from "../components/atom/AtomCurrentBgUrl";
import { getPassport, customizeProfileData } from "../api";
import { Listbox } from "@headlessui/react";
import { useRecoilState } from "recoil";
import { AtomBirthdayConverted } from "./atom/AtomBirthdayConverted";
import { AtomCurrentFontAvailable } from "./atom/AtomCurrentFontAvailable";
const Form = () => {
  const h1 = {
    color: "#000",
    fontFamily: "Bebas Neue",
    fontSize: "30px",
  };
  const inputbox = {
    border: "1px solid #D6CBCB",
    backgroundColor: "rgba(225, 222, 222, 0.17)",
  };
  const [currentprofilename, setcurrentprofilename] = useRecoilState(AtomCurrentProfileName);
  const [usersprofile, setusersprofile] = useRecoilState(AtomUsersUrl);
  const [usersname, setusersname] = useRecoilState(AtomUsername);
  const [work, setwork] = useRecoilState(AtomWork);
  const [Description, setDescription] = useRecoilState(AtomDescription);
  const [userid, setuserid] = useRecoilState(AtomUserid);
  const [level, setlevel] = useRecoilState(AtomLevel);
  const [birthdayDisplay, setbirthdayDisplay] =useRecoilState(AtomBirthdayDisplay);
  const [birthdayValue, setbirthdayValue] = useState(AtomBirthdayConverted)
  const [font, setfont] = useRecoilState(AtomCurrentFontName);
  const [color, setcolor] = useRecoilState(AtomColor);
  const [currentFont, setcurrentFont] = useRecoilState(AtomCurrentFontName);
  const [BalanceRp, setBalanceRp] = useRecoilState(AtomBalanceRP);
  const [ProfileimageUrl, setProfileimageurl] = useRecoilState(AtomCurrentProfileUrl);
  const [AllProfileAvailable, setAllProfileAvailable] = useRecoilState(AtomCurrentProfileAvailable );
  const [AllFontsAvailable, setAllFontsAvailable] = useRecoilState(AtomCurrentFontAvailable)
  const [AllBadgesAvailable, setAllBadgesAvailable] = useRecoilState(AtomCurrentBadgeAvailable);
  const [CurrentBackgroundName, setCurrentBackgroundName] =useRecoilState(AtomCurrentBgName);
  const [CurrentBackgroundUrl, setCurrentBackgroundUrl] =useRecoilState(AtomCurrentBgUrl);
  const [AllBgAvailable, setAllBgAvailable] = useRecoilState(AtomCurrentBgAvailable);
  const [Badge1Name, setBadge1Name] = useRecoilState(AtomCurrentBadge1Name);
  const [Badge1Url, setBadge1Url] = useRecoilState(AtomCurrentBadge1Url);
  const [Badge2Name, setBadge2Name] = useRecoilState(AtomCurrentBadge2Name);
  const [Badge2Url, setBadge2Url] = useRecoilState(AtomCurrentBadge2Url);
  const [Badge3Name, setBadge3Name] = useRecoilState(AtomCurrentBadge3Name);
  const [Badge3Url, setBadge3Url] = useRecoilState(AtomCurrentBadge3Url);
  const [Badge4Name, setBadge4Name] = useRecoilState(AtomCurrentBadge4Name);
  const [Badge4Url, setBadge4Url] = useRecoilState(AtomCurrentBadge4Url);
  useEffect(() => {
    console.log(currentFont)

  }, [])


  const BackgroundJson = require("../BackgroundImage.json");
  const ProfileJson = require("../profileimg.json")
  const FontJson = require("../font.json")
  const BadgesJson = require("../badges.json")


  const textAreaDetails = (e) => {
    setDescription(e.target.value);
  };
  const birthdayfun = (e) => {
    const date = new Date(e.target.value);
    const month = date.toLocaleString("default", { month: "short" });
    setbirthdayDisplay(`${date.getDate()}/${month}`);
  };
  const addThisBg = (e) => {

    BackgroundJson.forEach((data)=> {
      if (data.tag == e.target.value) {
        setCurrentBackgroundName(data.tag)
        setCurrentBackgroundUrl(data.url)

      }
    })
  };
  const addThisProfile = (e)=>{
    ProfileJson.forEach((data) =>{
      if (data.tag == e.target.value) {
        setcurrentprofilename(data.tag)
        setProfileimageurl(data.url)
      }
    })
  }
  const addThisFont = (e)=>{
    FontJson.forEach((data) =>{
      if (data.tag == e.target.value) {
        setcurrentFont(data.tag)
      }
    })
  }
  const addThisBadge1 = (e)=>{
    BadgesJson.forEach((data) =>{
      if (data.tag == e.target.value) {
        setBadge1Name(data.tag)
        setBadge1Url(data.url)
      }
    })
  }
  const addThisBadge2 = (e)=>{
    BadgesJson.forEach((data) =>{
      if (data.tag == e.target.value) {
        setBadge2Name(data.tag)
        setBadge2Url(data.url)
      }
    })
  }
  const addThisBadge3 = (e)=>{
    BadgesJson.forEach((data) =>{
      if (data.tag == e.target.value) {
        setBadge3Name(data.tag)
        setBadge3Url(data.url)
      }
    })
  }
  const addThisBadge4 = (e)=>{
    BadgesJson.forEach((data) =>{
      if (data.tag == e.target.value) {
        setBadge4Name(data.tag)
        setBadge4Url(data.url)
      }
    })
  }
  const addThisColor = (e)=>{
    setcolor(e.target.value)
  }
  const SubmitForm = (e) => {
    e.preventDefault();
    getPassport().then((data)=>{
    customizeProfileData(
      data.user.id,
      Description,
      currentprofilename,
      CurrentBackgroundName,
      color,
      birthdayDisplay,
      currentFont,
      Badge1Name,
      Badge2Name,
      Badge3Name,
      Badge4Name
    )
    .then(function (response) {
      console.log(response);
    })
    .catch(function (error) {
      console.log(error);
    });
  })
  };
  const labelClass = "block font-Bebas text-lg tracking-wider text-white/80 mb-1.5";
  const inputClass = "block w-full rounded-xl border border-white/15 bg-white/5 text-white py-2.5 px-3.5 text-sm font-poppins placeholder-white/30 focus:border-reored focus:ring-2 focus:ring-reored/40 focus:outline-none transition-colors duration-200 [&>option]:bg-voidcard [&>option]:text-white";

  return (
    <>
      <div className="font-poppins">
        <form onSubmit={SubmitForm} method="POST">
          <div className="glass p-6 sm:p-8">
            <h3 className="font-Bebas text-3xl tracking-wide text-white">
              Profile Settings
            </h3>
            <p className="mt-1 text-sm text-white/45 mb-7">
              This information will be displayed publicly so be careful what
              you share.
            </p>
            <div className="space-y-6">
                  <div>
                    <label
                      htmlFor="about"
                      className={labelClass}
                    >
                      Description
                    </label>
                    <div className="mt-1">
                      <textarea
                        rows={3}
                        className={inputClass}
                        placeholder="Tell Claydon who you areâ€¦"
                        name="description"
                        maxLength="150"
                        value={Description}
                        onChange={textAreaDetails}
                      />
                    </div>
                    <p className="mt-2 text-xs text-white/35">
                      Brief description for your profile (150 chars max)
                    </p>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/*<div>
                  <label className="block text-sm font-medium text-gray-700">Profile photo</label>
                  <div className="mt-1 flex justify-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6">
                    <div className="space-y-1 text-center">
                      <svg
                        className="mx-auto h-12 w-12 text-gray-400"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                        aria-hidden="true"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <div className="flex text-sm text-gray-600">
                        <label
                          htmlFor="file-upload"
                          className="relative cursor-pointer rounded-md bg-white font-medium text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:bg-reored focus-within:ring-offset-2 hover:text-indigo-500"
                        >
                          <span>Upload a file</span>
                          <input id="file-upload" name="file-upload" type="file" className="sr-only" />
                        </label>
                        <p className="pl-1">or drag and drop</p>
                      </div>
                      <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
                    </div>
                  </div>
                    </div>*/}
                  <div className="col-span-6 sm:col-span-3">
                    <label
                      htmlFor="profile"

                      className={labelClass}
                    >
                      Profile Image
                    </label>
                    <select
                    onChange={addThisProfile}
                      id="profile"
                      name="profile"
                      value={currentprofilename}
                      className={inputClass}
                    >
                      {AllProfileAvailable.map((value) => (
                        <option value={value}>{value}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label
                      htmlFor="bg"
                      className={labelClass}
                    >
                      Background Image
                    </label>
                    <select
                      id="bg"
                      name="bg"
                      value={CurrentBackgroundName}
                      onChange={addThisBg}
                      className={inputClass}
                    >
                              {AllBgAvailable.map((value) => (
                <option value={value}>{value}</option>
              ))}
                    </select>
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label
                      htmlFor="font"


                      className={labelClass}
                    >
                      Choose your font
                    </label>
                    <select
                      id="font"
                      name="font"
                      value={currentFont}
                      onChange={addThisFont}
                      className={inputClass}
                    >
                        {AllFontsAvailable.map((value) => (
                <option value={value}>{value}</option>
              ))}
                    </select>
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label
                      htmlFor="birthday"
                      className={labelClass}
                    >
                      Select Birthday
                    </label>
                    <input
                      type="date"
                      id="birthday"
                      name="birthday"
                      onChange={birthdayfun}
                      className={inputClass}
                    ></input>
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label
                      htmlFor="cor"
                      className={labelClass}
                    >
                      Select Color
                    </label>
                    <input
                      type="color"
                      id="cor"
                      name="cor"
                      value={color}
                      onChange={addThisColor}
                      className="block w-full h-11 rounded-xl border border-white/15 bg-white/5 cursor-pointer p-1.5"
                    ></input>
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label
                      htmlFor="b1"
                      className={labelClass}
                    >
                      Select Badge 1
                    </label>
                    <select
                      id="b1"
                      name="b1"
                      value={Badge1Name}
                      onChange={addThisBadge1}
                      className={inputClass}
                    >
                      {AllBadgesAvailable.map((value) => (
                        <option value={value}>{value}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label
                      htmlFor="b2"
                      className={labelClass}
                    >
                      Select Badge 2
                    </label>
                    <select
                      id="b2"
                      name="b2"
                      value={Badge2Name}
                      onChange={addThisBadge2}
                      className={inputClass}
                    >
                     {AllBadgesAvailable.map((value) => (
                        <option value={value}>{value}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label
                      htmlFor="b3"
                      className={labelClass}
                    >
                      Select Badge 3
                    </label>
                    <select
                      id="b3"
                      name="b3"
                      value={Badge3Name}
                      onChange={addThisBadge3}
                      className={inputClass}
                    >
                      {AllBadgesAvailable.map((value) => (
                        <option value={value}>{value}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label
                      htmlFor="b4"
                      className={labelClass}
                    >
                      Select Badge 4
                    </label>
                    <select
                      id="b4"
                      name="b4"
                      value={Badge4Name}
                      onChange={addThisBadge4}
                      className={inputClass}
                    >
                      {AllBadgesAvailable.map((value) => (
                        <option value={value}>{value}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="text-right pt-2">
                  <button
                    type="submit"
                    className="inline-flex justify-center rounded-full bg-reored py-3 px-8 font-Bebas text-lg tracking-widest text-white shadow-[0_0_25px_rgba(213,60,53,0.3)] hover:bg-red-600 hover:shadow-[0_0_35px_rgba(213,60,53,0.5)] focus:outline-none transition-all duration-300 cursor-pointer"
                  >
                    Apply Changes
                  </button>
                </div>
              </div>
            </div>
        </form>
      </div>
    </>
  );
};

export default Form;
